import React from 'react';
import CampoBuscarPersona from '../../UI/campos/CampoBuscarPersona.js';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import styles from '../EditarItemLista.module.css';

const CamposPersonaParientes = (props) => {
  const item = props.item;
  const editar = props.editar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Parentesco</td>
        <td className={`${styles.valor}`}>
          <CampoComboParametro
            nombre={Campos.Parentesco.TIPO_PARENTESCO}
            tipoParametro={TipoParametro.TIPO_PARENTESCO}
            estilo={`${styles.comboDatos}`}
            valor={item.tipoParentesco}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Pariente</td>
        <td className={`${styles.valor}`}>
          <CampoBuscarPersona
            nombre={Campos.Parentesco.PARIENTE}
            valor={item.pariente}
            editar={editar}
            onPersonaElegida={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposPersonaParientes;
